import React from 'react';

const SvgArrowRightOutline = props => (
  <svg width={5} height={9} {...props}>
    <path
      d="M3.986 4.5L.123.705a.408.408 0 0 1 0-.584.425.425 0 0 1 .594 0l4.16 4.087a.408.408 0 0 1 0 .584L.717 8.879a.425.425 0 0 1-.594 0 .408.408 0 0 1 0-.584L3.986 4.5z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowRightOutline;
